import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import type { QuickAction } from "@/services/api/dashboard";
import { fallbackIcons, getToneStyle, iconMap } from "./dashboardUi";
import { SectionHeader } from "./SectionHeader";

type QuickActionsProps = {
  actions: QuickAction[];
};

export function QuickActions({ actions }: QuickActionsProps) {
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
      <SectionHeader title="Quick Actions" />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {actions.map((action) => {
          const Icon = iconMap[action.iconName] || fallbackIcons.bot;
          const tone = getToneStyle(action.colorTone);

          return (
            <Link
              key={action.actionId}
              to={action.routePath}
              className={`grid min-h-[84px] grid-cols-[42px_minmax(0,1fr)_22px] items-center gap-3 rounded-lg border p-4 ${tone.soft} ${tone.border}`}
            >
              <Icon size={32} className={tone.text} />
              <span className="min-w-0">
                <strong className="block truncate text-sm font-bold text-slate-900">
                  {action.actionTitle}
                </strong>
                <small className="mt-1 block truncate text-xs font-medium text-slate-500">
                  {action.actionDescription}
                </small>
              </span>
              <ChevronRight size={22} className="text-slate-900" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}
